/**
 * Chaves reservadas do contexto URA (espelha API chatbotReservedContextKeys).
 */

const RESERVED_CONTEXT_KEYS = new Set([
  "resposta",
  "mensagem",
  "protocolo",
  "retorno",
  "encerrado",
  "id_lead",
  "id_usuario",
  "id_cliente",
  "id_conversa_ura",
  "ura_waiting_since",
  "ura_inactivity_fired",
  "operador",
  "pontuacao",
  "tags",
  "tagscliente",
  "id_transacao",
  "qrcodepixreserva",
  "planilha",
  "planilha_count",
  "resultadoconsultaapi",
  "cliente",
  "nomecliente",
  "nomeclientevalido",
  "emailcliente",
  "telefonecliente",
  "celularcliente",
  "cpfcliente",
  "cnpjcliente",
  "etapaconsciencia",
  "cadastroencontrado",
  "respostaagente",
  "datacompleta",
  "data",
  "dia",
  "mes",
  "ano",
  "horacompleta",
  "hora",
  "minuto",
  "segundo",
  "diasemana",
  "datadigitada",
  "horadigitada",
  "datadevolta",
  "origem",
  "destino",
  "orgaoconcedente",
  "tiporota",
  "dataorgaoconcedente",
  "erroconsultaorgaoconcedente",
  "retornoviagem",
  "resultadoconsultahorarios",
  "erroconsultahorarios",
  "opcaoreserva",
  "opcaoreservavolta",
  "resultadoconsultaopcaoselecionada",
  "resultadoconsultaassentos",
  "erroconsultaassentos",
  "assentoselecionado",
  "assentoselecionadovolta",
  "nomepassageiro",
  "documentopassageiro",
  "cpfpagador",
  "periodoviagem",
  "periodoviagemvolta",
  "formatadonomecidadeorigem",
  "formatadonomecidadedestino",
  "voltaformatadonomecidadeorigem",
  "voltaformatadonomecidadedestino",
  "horapartida",
  "horachegada",
  "valor",
  "classesuburbano",
  "voltahorapartida",
  "voltahorachegada",
  "voltavalor",
  "emailpassageiro",
  "passageironome",
  "passageirodocumento",
  "dadosdospassageiros",
  "dadospassageiros",
  "errosalvarassento",
  "voltaerrosalvarassento",
  "assentosdisponiveis",
  "assentosdisponiveisvolta",
  "assentos",
  "viagem",
  "viagemvolta",
  "viagens",
  "valorpagamento",
  "quantidade_passageiros",
  "data_hoje",
  "data_hoje_us",
  "endereco",
  "bairro",
  "cidade",
  "uf",
  "tagcliente",
  "campanha",
  "produto",
  "datanascimentocliente",
  "filtroprodutos",
  "lgpd",
  "origemencomenda",
  "destinoencomenda",
  "valornf",
  "peso",
  "largura",
  "altura",
  "comprimento",
]);

const CUSTOM_KEY_RE = /^[a-z][a-z0-9_]{0,63}$/;

export function normalizeContextKey(raw) {
  let key = String(raw || "").trim();
  if (key.startsWith("$")) key = key.slice(1);
  if (key.startsWith("{{") && key.endsWith("}}")) {
    key = key.slice(2, -2).trim();
  }
  return foldAccents(key);
}

export function foldAccents(raw) {
  return String(raw || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

export function validateCustomContextKey(raw) {
  const key = normalizeContextKey(raw);
  if (!key) {
    return { ok: false, key: "", message: "Informe a chave do contexto." };
  }
  if (!CUSTOM_KEY_RE.test(key)) {
    return {
      ok: false,
      key,
      message:
        "Use apenas letras minúsculas, números e _ (máx. 64 caracteres, começando com letra). Ex.: mensagem_cliente",
    };
  }
  if (RESERVED_CONTEXT_KEYS.has(key)) {
    return {
      ok: false,
      key,
      message: `A chave "${key}" é reservada pelo sistema e não pode ser usada.`,
    };
  }
  return { ok: true, key, message: "" };
}
